const TitleComponent: React.FunctionComponent = () => {
  return (
    <div className="hero-body">
      <div className="container has-text-centered">
        <h1 className="title">Neditor</h1>
        <h2 className="subtitle">Not your everyday code editor</h2>
      </div>
    </div>
  );
};

export default TitleComponent;
